import './Card.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Картка документа — ADR-0004.
 *
 * Було: прев'ю з filter: blur(10px) saturate(20%) і rotateX(45deg), яке
 * ставало різким тільки в активному слайді Swiper; сама назва документа й
 * кнопка «Відкрити» жили в окремій накладці на весь екран.
 * Стало: прев'ю, назва і посилання на файл в одній картці.
 */
export default function Card({ card }) {
  const language = useLanguage();
  const apiBase = process.env.REACT_APP_BASE_API_URL || '';

  const preview = card.preview?.url;
  const file = card.file?.url;
  const name = card.name;

  return (
    <a
      className='document-card'
      href={file ? `${apiBase}${file}` : undefined}
      target='_blank'
      rel='noreferrer'
      aria-disabled={!file}
    >
      <span className='document-card-preview'>
        {preview ? (
          <img src={`${apiBase}${preview}`} alt='' className='document-card-photo' loading='lazy' />
        ) : (
          <span className='document-card-photo document-card-photo--empty' aria-hidden='true' />
        )}
      </span>

      <span className='document-card-body'>
        <span className='document-card-name'>{name}</span>
        <span className='document-card-action'>
          {language === 'en' ? 'Open PDF' : 'Відкрити PDF'}
          <svg className='btn-arrow' width='16' height='16' viewBox='0 0 24 24' aria-hidden='true'>
            <path
              d='M5 12h14M13 6l6 6-6 6'
              fill='none'
              stroke='currentColor'
              strokeWidth='1.6'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </span>
      </span>
    </a>
  );
}
